/* eslint-disable @typescript-eslint/camelcase */
import moment from "moment";
import {
  QueryParamsEntities4,
  QueryParamsEntitiesV3,
  TableErrorResponse
} from "./MainApp";
import { Pagination, PaginationV2 } from "@/domain/entities/Pagination";
import { getHubData } from "@/app/infrastructures/misc/Cookies";
import { ConvertObjectCamelToSnakeCaseV2 } from "@/app/infrastructures/misc/common-library/ConvertObjectCamelToSnakeCase";
export class HangingIncomingSummary {
  lastSync = "";
  activitiesPending = 0;
  activitiesDone = 0;
  totalActivities = 0;
  awbHangingPending = 0;
  awbHangingDone = 0;
  totalAwbHanging = 0;
  bagHangingPending = 0;
  bagHangingDone = 0;
  totalBagHanging = 0;
  sttHangingPending = 0;
  sttHangingDone = 0;
  totalSttHanging = 0;
  byStatus: ByStatusDetail[] = [];

  constructor(fields?: Partial<HangingIncomingSummary>) {
    Object.assign(this, fields);
  }
}

export class ByStatusDetail {
  status = "";
  awb = 0;
  totalBag = 0;
  totalStt = 0;

  constructor(fields?: Partial<ByStatusDetail>) {
    Object.assign(this, fields);
  }
}

export class HangingIncomingFilterRequest {
  search = "";
  days = "";
  existenceStatus = "";
  statusFollowUp = "";

  constructor(fields?: Partial<HangingIncomingFilterRequest>) {
    Object.assign(this, fields);
  }

  toQueryString(): string {
    return new QueryParamsEntities4({
      ...this,
      hub_id: getHubData()?.hubId || 0
    }).queryString;
  }
}

export class HangingLastMileFilterRequest {
  search = "";
  days = "";
  existenceStatus = "";
  statusFollowUp = "";

  constructor(fields?: Partial<HangingLastMileFilterRequest>) {
    Object.assign(this, fields);
  }

  toQueryString(): string {
    return new QueryParamsEntities4({
      ...this,
      hub_id: getHubData()?.hubId || 0
    }).queryString;
  }
}

export class FilterRiwayatRequest {
  search = "";
  days = [];
  existenceStatus = "";
  date = "";
  page = 1;
  limit = 10;

  constructor(fields?: Partial<FilterRiwayatRequest>) {
    Object.assign(this, fields);
  }

  toQueryString(): string {
    return new QueryParamsEntities4({
      ...this,
      hub_id: getHubData()?.hubId || 0
    }).queryString;
  }
}

// confirmation
export class SubmitHangingConfirmationFollowUp {
  success = false;
  message = {
    en: "",
    id: ""
  };
  data = {
    activityId: "",
    statusFollowUp: "",
    confirmedAt: ""
  };

  constructor(fields?: Partial<SubmitHangingConfirmationFollowUp>) {
    Object.assign(this, fields);
  }
}

export class SubmitHangingConfirmationUpdateStatus {
  success = false;
  message = {
    en: "",
    id: ""
  };
  data = {
    activityId: "",
    statusFollowUp: "",
    confirmedAt: ""
  };

  constructor(fields?: Partial<SubmitHangingConfirmationUpdateStatus>) {
    Object.assign(this, fields);
  }
}

export class FollowUpSTT {
  no = 0;
  bagNo = "";
  sttNo = "";
  isAggregator = false;
  hangingDays = 0;
  existenceStatus = "";
  existenceLocation = "";
  existenceUsername = "";
  existenceFindAt = "";
  isChecked = false;

  constructor(fields?: Partial<FollowUpSTT>) {
    Object.assign(this, fields);
  }
}

export class AWBSummary {
  bag = 0;
  stt = 0;

  constructor(fields?: Partial<AWBSummary>) {
    Object.assign(this, fields);
  }
}

export class AWB {
  awbNo = "";
  origin3lc = "";
  originName = "";
  arrivedAt = "";
  summary: AWBSummary = new AWBSummary();
  stts: FollowUpSTT[] = [];
  isChecked = false;

  constructor(fields?: Partial<AWB>) {
    Object.assign(this, fields);
  }
}

export class GroupSummary {
  totalAwb = 0;
  totalOrigin = 0;
  totalPiece = 0;
  totalBag = 0;
  totalStt = 0;

  constructor(fields?: Partial<GroupSummary>) {
    Object.assign(this, fields);
  }
}

export class FollowUpGroup {
  groupName = "";
  summary: GroupSummary = new GroupSummary();
  awbs: AWB[] = [];
  isChecked = false;

  constructor(fields?: Partial<FollowUpGroup>) {
    Object.assign(this, fields);
  }
}

export class FollowUpInfo {
  courierName = "";
  courierPhone = "";
  username = "";
  origin3lc = "";
  originName = "";

  constructor(fields?: Partial<FollowUpInfo>) {
    Object.assign(this, fields);
  }
}

export class HangingIncoming {
  activityId = 0;
  activityType = "";
  followUpStatus = "";
  followUpByUsername = "";
  followUpAt = "";
  followUp: FollowUpInfo = new FollowUpInfo();
  isCollapsed = false;
  groups: FollowUpGroup[] = [];

  constructor(fields?: Partial<HangingIncoming>) {
    Object.assign(this, fields);
  }
}

export class RiwayatHangingLasmileRequest {
  search = "";
  days: any = [];
  existenceStatus = "";
  startDate = "";
  endDate = "";
  page = 1;
  limit = 10;

  constructor(fields?: Partial<RiwayatHangingLasmileRequest>) {
    Object.assign(this, fields);
  }

  toQueryString(): string {
    return new QueryParamsEntitiesV3(
      ConvertObjectCamelToSnakeCaseV2({
        ...this,
        hubId: getHubData()?.hubId || 0
      })
    ).queryString;
  }
}

export class RiwayatHangingLasmileEntities {
  pagination: Pagination;
  data: ListRiwayatHangingLasmile[];
  constructor(pagination: Pagination, data: ListRiwayatHangingLasmile[]) {
    this.pagination = pagination;
    this.data = data;
  }
}
export class ListRiwayatHangingLasmile {
  manifestNo = "";
  sttNo = "";
  aggregator = false;
  hangingDays = 0;
  existenceStatus = "";
  existenceLocation = "";
  existenceUsername = "";
  existenceFindAt = "";
  status = "";
  username = "";
  createdAt = "";

  constructor(fields?: Partial<ListRiwayatHangingLasmile>) {
    Object.assign(this, fields);
  }
}

export class HistoryFollowUpIncomingEntities {
  pagination: Pagination;
  data: HistoryFollowUpIncoming[];
  constructor(pagination: Pagination, data: HistoryFollowUpIncoming[]) {
    this.pagination = pagination;
    this.data = data;
  }
}
export class HistoryFollowUpIncoming {
  date = "";
  activities: ActivitiesDetail[] = [];

  constructor(fields?: Partial<HistoryFollowUpIncoming>) {
    Object.assign(this, fields);
  }
}

export class FollowUpDetail {
  courierName = "";
  courierPhone = "";
  username = "";
  origin3lc = "";
  originName = "";

  constructor(fields?: Partial<FollowUpDetail>) {
    Object.assign(this, fields);
  }
}

export class ActivitiesDetail {
  activityId = 0;
  activityType = "";
  statusFollowUp = "";
  followUp: FollowUpDetail = new FollowUpDetail();
  username = "";
  createdAt = "";

  constructor(fields?: Partial<ActivitiesDetail>) {
    Object.assign(this, fields);
  }
}

export class HistoryFollowUpIncomingRequest {
  activityType = "";
  date = "";
  page = 1;
  limit = 10;
  startDate = "";
  endDate = "";

  constructor(fields?: Partial<HistoryFollowUpIncomingRequest>) {
    Object.assign(this, fields);
  }

  toQueryString(): string {
    return new QueryParamsEntities4({
      ...this,
      hub_id: getHubData()?.hubId || 0
    }).queryString;
  }
}

export class HistoryHangingIncomingFilterRequest {
  search = "";
  days: any = "";
  existenceStatus = "";
  startDate = new Date().toISOString().split("T")[0];
  endDate = new Date().toISOString().split("T")[0];
  page = 1;
  limit = 10;

  constructor(fields?: Partial<HistoryHangingIncomingFilterRequest>) {
    Object.assign(this, fields);
  }

  toQueryString(): string {
    return new QueryParamsEntities4({
      ...this,
      startDate: this.startDate
        ? moment(this.startDate).format("YYYY-MM-DD")
        : "",
      endDate: this.endDate ? moment(this.endDate).format("YYYY-MM-DD") : "",
      hub_id: getHubData()?.hubId || 0
    }).queryString;
  }
}

export class HistoryHangingIncoming {
  awbNo = "";
  bagNo = "";
  sttNo = "";
  aggregator = false;
  hangingDays = 0;
  existenceStatus = "";
  existenceLocation = "";
  existenceUsername = "";
  existenceFindAt = "";
  status = "";
  username = "";
  createdAt = "";

  constructor(fields?: Partial<HistoryHangingIncoming>) {
    Object.assign(this, fields);
  }
}

export class HistoryHangingIncomingEntities {
  pagination = new Pagination(1, 10, 0);
  data: HistoryHangingIncoming[] = [];

  constructor(fields?: Partial<HistoryHangingIncomingEntities>) {
    Object.assign(this, fields);
  }
}

export class HangingIncomingUpdateStatus {
  customProcessId = 0;
  totalSttSuccess = 0;
  totalSttFailed = 0;

  constructor(fields?: Partial<HangingIncomingUpdateStatus>) {
    Object.assign(this, fields);
  }
}

export class HistoryHanging {
  pagination = new PaginationV2();
  data: ListRiwayatHangingLasmile[] = [];
  error = new TableErrorResponse();
  params = new RiwayatHangingLasmileRequest();
  loading = true;

  constructor(fields?: Partial<HistoryHanging>) {
    Object.assign(this, fields);
  }
}
